"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationSpec = exports.castRelations = exports.RelationSide = exports.RelationSpecSchema = void 0;
var ajv_1 = __importDefault(require("ajv"));
var common_1 = require("./common");
// EntitySpec schema in json-schema format
exports.RelationSpecSchema = {
    type: "object",
    properties: __assign(__assign({}, common_1.BaseSpecSchema.properties), { origin: { type: "string" }, destination: { type: "string" }, cardinality: common_1.CardinalitySchema }),
    required: __spreadArrays(common_1.BaseSpecSchema.required, [
        "origin",
        "destination",
        "cardinality",
    ]),
};
var RelationSide;
(function (RelationSide) {
    RelationSide[RelationSide["ManyToOne"] = 0] = "ManyToOne";
    RelationSide[RelationSide["OneToMany"] = 1] = "OneToMany";
    RelationSide[RelationSide["ManyToMany"] = 2] = "ManyToMany";
})(RelationSide = exports.RelationSide || (exports.RelationSide = {}));
var ajv = new ajv_1.default();
var validateArray = ajv.compile({ type: "array", items: exports.RelationSpecSchema });
// Cast an array of RelationSpecs
exports.castRelations = function (items) {
    var valid = validateArray(items);
    if (!valid)
        throw new Error(JSON.stringify(validateArray.errors));
    return items.map(function (item) { return new RelationSpec(item); });
};
// RelationSpec class
var RelationSpec = /** @class */ (function (_super) {
    __extends(RelationSpec, _super);
    function RelationSpec(inner) {
        var _this = _super.call(this, inner) || this;
        // Basic getters
        _this.getOrigin = function () { return _this.relation.origin; };
        _this.getDestination = function () { return _this.relation.destination; };
        _this.getCardinality = function () { return _this.relation.cardinality; };
        // Computes the relation side for the given entity URN.
        // NOTE: Returns undefined if the URN is on neither side of the relation.
        _this.getSide = function (urn) {
            var isOrigin = _this.getOrigin() === urn;
            var isDestination = _this.getDestination() === urn;
            if (!isOrigin && !isDestination)
                return undefined;
            switch (_this.getCardinality()) {
                case common_1.Cardinality.OneToMany:
                    return isOrigin
                        ? RelationSide.OneToMany
                        : RelationSide.ManyToOne;
                case common_1.Cardinality.ManyToMany:
                    return RelationSide.ManyToMany;
            }
        };
        // keep inner object for later use
        _this.relation = inner;
        return _this;
    }
    return RelationSpec;
}(common_1.BaseSpec));
exports.RelationSpec = RelationSpec;
